import type { SVGProps } from "react"
import React from "react"

export const Twitter: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 32,
  height = 32,
  fill = "#000",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <title>Twitter icon</title>
    <path
      fill={fill}
      d="M25.5577 10.9639C26.4971 10.241 27.3425 9.37349 28 8.36145C27.1546 8.74699 26.1683 9.03614 25.182 9.13253C26.2153 8.50602 26.9667 7.54217 27.3425 6.33735C26.4031 6.91566 25.3229 7.3494 24.2427 7.59036C23.3033 6.57831 22.0352 6 20.6262 6C17.9022 6 15.6947 8.26506 15.6947 11.0602C15.6947 11.4458 15.7417 11.8313 15.8356 12.2169C11.7495 11.9759 8.08611 9.95181 5.64384 6.91566C5.22114 7.63855 4.9863 8.50602 4.9863 9.46988C4.9863 11.2048 5.8317 12.747 7.19374 13.6627C6.3953 13.6145 5.59687 13.4217 4.93933 13.0361V13.0843C4.93933 15.5422 6.63014 17.5663 8.88454 18.0482C8.50881 18.1446 8.03914 18.241 7.61644 18.241C7.28767 18.241 7.00587 18.1928 6.6771 18.1446C7.28767 20.1687 9.11937 21.6145 11.2798 21.6627C9.58904 23.012 7.47554 23.8313 5.17417 23.8313C4.75147 23.8313 4.37573 23.7831 4 23.7349C6.16047 25.1807 8.74364 26 11.5616 26C20.6262 26 25.5577 18.3373 25.5577 11.6386C25.5577 11.3976 25.5577 11.2048 25.5577 10.9639Z"
    />
  </svg>
)
